import {takeEvery} from 'redux-saga/effects'
import {
  GET_DYNAMIC_VARIABLES,
  GET_DYNAMIC_VARIABLE_VALUES,
} from 'setup/redux/Actions/DynamicVariable/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_DYNAMIC_VARIABLES, fetchData)
  yield takeEvery(GET_DYNAMIC_VARIABLE_VALUES, fetchData)
}

export default dataSaga
